import { Route, Routes } from 'react-router-dom';
import { CmsRootProvider } from '@/components/CmsRootProvider';
import { AnalyticsRouteTracker } from '@/components/analytics/AnalyticsRouteTracker';
import ScrollToTop from '@/routes/ScrollToTop';
import SearchModal from '@/components/help-center/SearchModal';
import HelpFloatingButton from '@/components/help-center/HelpFloatingButton';
import CustomScrollbar from '@/components/help-center/CustomScrollbar';
import { PublicLayout } from '@/routes/ComingSoonGuard';
import PainelRouter from '@/routes/PainelRouter';
import HomePage from '@/pages/HomePage';
import GuideCategoryPage from '@/pages/GuideCategoryPage';
import GuideArticlePage from '@/pages/GuideArticlePage';
import PowersPage from '@/pages/PowersPage';
import PowerDetailPage from '@/pages/PowerDetailPage';
import AcesPage from '@/pages/AcesPage';
import AceDetailPage from '@/pages/AceDetailPage';
import ChangelogPage from '@/pages/ChangelogPage';
import EquipePage from '@/pages/EquipePage';
import RegrasPage from '@/pages/RegrasPage';
import CondutaPage from '@/pages/CondutaPage';
import TermosPage from '@/pages/TermosPage';
import PrivacidadePage from '@/pages/PrivacidadePage';
import SmileyTestPage from '@/pages/SmileyTestPage';
import FairtradePage from '@/pages/FairtradePage';
import ComingSoonPage from '@/pages/ComingSoonPage';
import AdminLoginPage from '@/components/admin/AdminLoginPage';
import { AdminLoginToaster } from '@/components/admin/AdminLoginToaster';
import AdminRootRedirect from '@/components/admin/AdminRootRedirect';
import NotFoundPage from '@/pages/NotFoundPage';

export default function App() {
  return (
    <CmsRootProvider>
      <ScrollToTop />
      <AnalyticsRouteTracker />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path="powers" element={<PowersPage />} />
          <Route path="powers/:power" element={<PowerDetailPage />} />
          <Route path="aces" element={<AcesPage />} />
          <Route path="aces/:slug" element={<AceDetailPage />} />
          <Route path="changelog" element={<ChangelogPage />} />
          <Route path="equipe" element={<EquipePage />} />
          <Route path="regras" element={<RegrasPage />} />
          <Route path="conduta" element={<CondutaPage />} />
          <Route path="termos" element={<TermosPage />} />
          <Route path="privacidade" element={<PrivacidadePage />} />
          <Route path="smileytest" element={<SmileyTestPage />} />
          <Route path="fairtrade" element={<FairtradePage />} />
          <Route path="coming-soon" element={<ComingSoonPage />} />
          <Route path=":category" element={<GuideCategoryPage />} />
          <Route path=":category/:slug" element={<GuideArticlePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route
          path="admin"
          element={
            <AdminRootRedirect
              fallbackLogin="/admin/login"
              fallbackDashboard="/painel"
            />
          }
        />
        <Route
          path="admin/login"
          element={
            <>
              <AdminLoginPage />
              <AdminLoginToaster />
            </>
          }
        />
        <Route path="painel/*" element={<PainelRouter />} />
      </Routes>

      <SearchModal />
      <HelpFloatingButton />
      <CustomScrollbar />
    </CmsRootProvider>
  );
}
